import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchAttendanceRulesRequest, deleteAttendanceRuleRequest } from "../../../api/attendanceRule";
import { formatAttendanceRuleType, formatAttendanceRuleCalculationType } from "../../../helpers/functions/attendanceRule";

class AttendanceRuleTable extends Component {

  state = {
    data: null,
    error: null,
    loading: false
  };

  componentDidMount() {
    if (!this.state.data)
      this.fetchAttendanceRuleData()
  }

  fetchAttendanceRuleData(){
    this.setState({
      loading: true
    });
    fetchAttendanceRulesRequest(
      result => this.setState({data: result, error: null, loading: false}),
      error => this.setState({error: error.message, loading: false})
    )
  };

  deleteAttendanceRule = (id) => {
    deleteAttendanceRuleRequest(
      id,
      result => this.fetchAttendanceRuleData(),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );
  }

  render() {
    const { data } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="Attendance Rule Table"
                category="List of AttendanceRule entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm('attendance-rule')}>
                      New Entry
                    </CustomButtom>
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Name</th>
                          <th>Calculation Type</th>
                          <th>Description</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ?
                          <td colSpan="5" style={{padding: "0"}}>
                            <div className="loader"></div>
                          </td> 
                          :
                           (data && data.length > 0 )
                          ? data.map(instance => {
                            return (
                              <tr key={instance._id}>
                                <td>{formatAttendanceRuleType(instance.type) || "N/A"}</td>
                                <td>{instance.label || "N/A"}</td>
                                <td>{formatAttendanceRuleCalculationType(instance.calculationType) ||"N/A"}</td>
                                <td>{instance.description || "N/A"}</td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToDetails('attendance-rule', instance._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <CustomButtom 
                                      bsStyle="info" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToEditForm('attendance-rule', instance._id)}
                                    >
                                      <i className="fa fa-edit" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.deleteAttendanceRule(instance._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )}
                          )
                          : (
                            <tr>
                              <td colSpan='2'>There are no instances in the database yet.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default AttendanceRuleTable;
